<!-- @format -->
<template>
    <div class="phone-number-edit-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Edit Phone Number</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>

            <div class="content-wrapper">
                <div v-if="isLoading" class="step">
                    <loading-screen-svg />
                </div>
                <div v-else>
                    <h4 class="title">Edit Phone Number Name</h4>
                    <app-input
                        v-model="phoneNumberName"
                        type="text"
                        placeholder="Enter phone number name"
                        class="phone-number-name-input" />
                    <div class="description">Optional: this name will be displayed alongside your phone number.</div>
                </div>
            </div>

            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="transparent-btn" @click="closeWidget">
                        Cancel
                    </app-button>
                </div>
                <div class="action-container">
                    <app-button
                        class="save-btn"
                        @click="closeWidget"
                    >
                        Save
                    </app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');
const AppInput = () => import('@/components/common/app-input');

import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'phone-number-edit-widget',

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'loading-screen-svg': LoadingScreenSvg,
        'app-input': AppInput,
    },

    
        props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            isLoading: true,
        };
    },

    created() {
        this.isLoading = false;
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },
    },
};
</script>

<style>
.phone-number-edit-widget .action-container,
.phone-number-edit-widget .action-buttons {
    display: flex;
    gap: 19px;
    align-items: center;
}

.phone-number-edit-widget.widget .content-wrapper {
    padding-top: 24px;
}

.phone-number-edit-widget .content-wrapper .title {
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
}

.phone-number-edit-widget .content-wrapper .description {
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    margin-top: 8px;
    color: var(--color-text-subtle);
}

.phone-number-edit-widget .action-container .secondary-btn {
    border: 2px solid var(--color-border-button-secondary);
    background: transparent;
    color: var(--color-text-button-secondary);
}

.phone-number-edit-widget .action-container .secondary-btn:hover {
    background: var(--color-background-button-secondary-hover);
    color: var(--color-text-button-secondary-hover);
}

.phone-number-edit-widget .app-button {
    height: 40px;
}

.phone-number-edit-widget .transparent-btn {
    background: transparent;
    color: var(--color-text-subtle);
}

.phone-number-edit-widget .widget-contents-container .transparent-btn:hover {
    background: var(--color-background-button-alternate-hover);
}
</style>
